'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdDirectionsRun = function MdDirectionsRun(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm16.5 32.3l-11.7-2.3 0.7-3.4 8.2 1.7 2.6-13.5-3 1.1v5.7h-3.3v-7.8l8.7-3.6c0.4 0 0.8-0.2 1.3-0.2 1.2 0 2.1 0.6 2.8 1.6l1.7 2.7c1.3 2.3 3.9 4 7.1 4v3.3c-3.6 0-6.9-1.6-9.1-4.1l-1 5 3.5 3.3v12.5h-3.4v-10l-3.5-3.3z m6-23.2c-1.8 0-3.4-1.5-3.4-3.3s1.6-3.3 3.4-3.3 3.3 1.5 3.3 3.3-1.5 3.3-3.3 3.3z' })
        )
    );
};

exports.default = MdDirectionsRun;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/directions-run.js
// module id = 2796
// module chunks = 0